/* KWD cart sounds — "Warm" pack. Synthesised with Web Audio, no audio files,
   no network cost. Every cue is under 0.4s and sits well below the page's own
   volume so it reads as feedback, not decoration.

   Sounds only ever fire after a real user gesture (browser autoplay policy does
   the same job as a guard: the AudioContext cannot start without one). That is
   deliberate — the cart page fires several /cart/update.js calls of its own on
   load, and those must stay silent.

   Off switch:  localStorage.setItem('kwd_sound','off')   then reload.
   Volume:      localStorage.setItem('kwd_sound_vol','0.3')  (0 to 1)
   Manual test: KWDSound.play('add')  */
(function(){
  'use strict';

  var FREE_CENTS = 15000;
  var ctx = null, armed = false;

  function enabled(){
    try{ return localStorage.getItem('kwd_sound') !== 'off'; }catch(e){ return true; }
  }
  function vol(){
    var v; try{ v = parseFloat(localStorage.getItem('kwd_sound_vol')); }catch(e){}
    return (isFinite(v) && v >= 0 && v <= 1) ? v : 0.45;
  }
  function audio(){
    if(!ctx){
      var C = window.AudioContext || window.webkitAudioContext;
      if(!C) return null;
      try{ ctx = new C(); }catch(e){ return null; }
    }
    if(ctx.state === 'suspended'){ try{ ctx.resume(); }catch(e){} }
    return ctx;
  }

  function env(g,t,a,d,p){
    g.gain.setValueAtTime(0.0001,t);
    g.gain.linearRampToValueAtTime(p,t+a);
    g.gain.exponentialRampToValueAtTime(0.0001,t+a+d);
  }
  function tone(t,f0,f1,dur,type,peak,atk){
    var c=audio(); if(!c) return;
    var o=c.createOscillator(), g=c.createGain();
    o.type=type; o.frequency.setValueAtTime(f0,t);
    if(f1 && f1!==f0) o.frequency.exponentialRampToValueAtTime(Math.max(20,f1),t+dur);
    env(g,t,atk||0.005,dur,peak*vol());
    o.connect(g); g.connect(c.destination);
    o.start(t); o.stop(t+dur+0.08);
  }
  function noise(t,dur,f0,f1,peak,q){
    var c=audio(); if(!c) return;
    var n=Math.max(1,Math.floor(c.sampleRate*dur));
    var b=c.createBuffer(1,n,c.sampleRate), d=b.getChannelData(0);
    for(var i=0;i<n;i++) d[i]=Math.random()*2-1;
    var s=c.createBufferSource(); s.buffer=b;
    var f=c.createBiquadFilter(); f.type='bandpass'; f.Q.value=q||1;
    f.frequency.setValueAtTime(f0,t);
    f.frequency.exponentialRampToValueAtTime(Math.max(40,f1),t+dur);
    var g=c.createGain(); env(g,t,0.006,dur,peak*vol());
    s.connect(f); f.connect(g); g.connect(c.destination);
    s.start(t); s.stop(t+dur+0.02);
  }

  var PACK = {
    add: function(t){ noise(t,0.045,1400,400,0.10,1.2); tone(t,392,523,0.10,'sine',0.42); tone(t+0.07,659,784,0.14,'sine',0.30,0.01); },
    up: function(t){ tone(t,587,784,0.07,'sine',0.34); },
    down: function(t){ tone(t,587,392,0.08,'sine',0.30); },
    remove: function(t){ tone(t,330,150,0.14,'triangle',0.30); noise(t,0.05,700,200,0.07,1); },
    open: function(t){ noise(t,0.24,260,2000,0.11,0.7); tone(t,175,294,0.20,'sine',0.16,0.03); },
    close: function(t){ noise(t,0.20,1800,240,0.10,0.7); tone(t,294,175,0.16,'sine',0.14,0.02); },
    ship: function(t){ [784,988,1175,1568].forEach(function(f,i){ tone(t+i*0.075,f,f,0.34,'sine',0.24,0.008); }); },
    checkout: function(t){ [523,659,784,1047].forEach(function(f,i){ tone(t+i*0.085,f,f,0.20,'sine',0.30,0.008); }); }
  };

  function play(name, delay){
    if(!armed || !enabled() || !PACK[name]) return;
    var c=audio(); if(!c) return;
    try{ PACK[name](c.currentTime + 0.02 + (delay||0)); }catch(e){}
  }

  /* First real gesture arms the whole thing and warms the AudioContext up so
     the very next cue has no start-up latency. */
  function arm(){
    if(armed) return;
    armed = true;
    audio();
    document.removeEventListener('pointerdown',arm,true);
    document.removeEventListener('keydown',arm,true);
    document.removeEventListener('touchstart',arm,true);
  }
  document.addEventListener('pointerdown',arm,true);
  document.addEventListener('keydown',arm,true);
  document.addEventListener('touchstart',arm,true);

  /* ---------- cart mutations ---------- */

  var prev = null;

  document.addEventListener('kwd:cart:updated', function(e){
    var d = e.detail || {}, cart = d.cart, why = d.reason;
    if(!cart) return;
    var now = { total: cart.total_price, count: cart.item_count, lines: (cart.items||[]).length };

    if(why === 'init' || why === 'poll' || !prev){ prev = now; return; }

    if(why === 'add' && now.count > prev.count) play('add');
    else if(now.lines < prev.lines) play('remove');
    else if(now.count > prev.count) play('up');
    else if(now.count < prev.count) play(now.count === 0 ? 'remove' : 'down');

    if(prev.total < FREE_CENTS && now.total >= FREE_CENTS) play('ship', 0.36);

    prev = now;
  });

  /* ---------- clicks that move no stock ---------- */

  function hit(el, sels){
    for(var i=0;i<sels.length;i++){ if(el.closest(sels[i])) return true; }
    return false;
  }

  document.addEventListener('click', function(e){
    var el = e.target && e.target.closest ? e.target : null;
    if(!el) return;

    if(hit(el,['#CartDrawer .closebtn','.drawer__header .closebtn'])){ play('close'); return; }
    if(hit(el,['.open_card_drawer','#mySid_new','.kwd-cart'])){ play('open'); return; }
    if(hit(el,['[name="checkout"]','.cart__checkout','.cart__submit','.blu1'])){ play('checkout'); return; }
  }, true);

  window.KWDSound = {
    play: function(n){ arm(); play(n); },
    names: Object.keys(PACK),
    on: function(){ try{ localStorage.removeItem('kwd_sound'); }catch(e){} },
    off: function(){ try{ localStorage.setItem('kwd_sound','off'); }catch(e){} }
  };
})();
